/**
 * @generated SignedSource<<3e481e581df63e102f84f6f8942a5bff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphVideo_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly chapters?: ReadonlyArray<{
      readonly startTimeInSeconds: AGG$Long | null;
      readonly title: string | null;
    } | null> | null;
    readonly createdBy?: {
      readonly thirdPartyUser: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly user: {
        readonly name: string;
      } | null;
    } | null;
    readonly durationInSeconds?: AGG$Long | null;
    readonly embedUrl?: string | null;
    readonly entityExtendedValues?: ReadonlyArray<{
      readonly dataType: string | null;
      readonly fieldDisplayName: {
        readonly displayName: string | null;
      } | null;
      readonly fieldId: string | null;
      readonly fieldValue: string | null;
      readonly isDisplayed: boolean | null;
    } | null> | null;
    readonly thumbnailUrl?: string | null;
  } | null;
  readonly excerpt: string | null;
  readonly id: string;
  readonly integrationId: string | null;
  readonly lastModifiedDate: string | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly permissionLevel: string | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphVideo_AtlassianSearchPage";
};
export type searchGraphVideo_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphVideo_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphVideo_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v4 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphVideo_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    (v4/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "durationInSeconds"
            },
            {
              "kind": "ScalarField",
              "name": "embedUrl"
            },
            {
              "kind": "ScalarField",
              "name": "thumbnailUrl"
            },
            {
              "concreteType": "ExternalEntityExtendedValue",
              "kind": "LinkedField",
              "name": "entityExtendedValues",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fieldId"
                },
                {
                  "kind": "ScalarField",
                  "name": "fieldValue"
                },
                {
                  "concreteType": "ExternalEntityExtendedValueDisplayName",
                  "kind": "LinkedField",
                  "name": "fieldDisplayName",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "isDisplayed"
                },
                {
                  "kind": "ScalarField",
                  "name": "dataType"
                }
              ]
            },
            {
              "concreteType": "ExternalChapter",
              "kind": "LinkedField",
              "name": "chapters",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "startTimeInSeconds"
                }
              ]
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ThirdPartyUser",
                  "kind": "LinkedField",
                  "name": "thirdPartyUser",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v5/*: any*/)
                  ]
                },
                {
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v5/*: any*/)
                  ]
                }
              ]
            }
          ],
          "type": "ExternalVideo"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "9e109d9d0c74c180e54fc688afabefa2";

export default node;
